export default "__VITE_ASSET__DKZxqa2T__"